module.exports = __webpack_public_path__ + "img/S@2x.ba4b4fc.jpg";